export default __webpack_public_path__ + "static/media/statement-skeleton.e0eea76a.svg";